import { composeRenderProps } from 'react-aria-components'
import { twMerge } from 'tailwind-merge'
import { tv } from 'tailwind-variants'

export type ExtractRenderPropsToVariants<T extends object> = Partial<{
  [Key in keyof T]: T[Key] extends boolean ? Partial<Record<'true' | 'false', string>> : Record<string, string>
}>

export const focusRing = tv({
  base: 'outline outline-baf-yellow-600/50 dark:baf-yellow-500/50 forced-colors:outline-[Highlight] outline-offset-2',
  variants: {
    isFocusVisible: {
      false: 'outline-0',
      true: 'outline-2',
    },
  },
})

export function composeTailwindRenderProps<T>(
  className: string | ((v: T) => string) | undefined,
  tw: string
): string | ((v: T) => string) {
  return composeRenderProps(className, className => twMerge(tw, className))
}
